import { Stack } from "@mui/material";
import { ReactNode, Ref } from "react";
import SimpleBarCore from "simplebar-core";

import { SECONDARY_SIDEBAR_WIDTH } from "../constants/theme";

import { ContentContainer, Sidebar } from "./components";

interface SidebarLayoutProps {
  children: ReactNode;
  showSidebar?: boolean;
  sidebarContent?: ReactNode;
  sidebarRef?: Ref<SimpleBarCore | null> | undefined;
  sidebarWidth?: number;
  hideable?: boolean;
}

export function SidebarLayout({
  sidebarContent,
  children,
  showSidebar = true,
  sidebarRef,
  hideable,
  sidebarWidth = SECONDARY_SIDEBAR_WIDTH,
}: SidebarLayoutProps) {
  return (
    <Stack id="secondary-sidebar" direction="row" width="100%">
      {showSidebar && (
        <Sidebar ref={sidebarRef} hideable={hideable} sidebarWidth={sidebarWidth}>
          {sidebarContent}
        </Sidebar>
      )}

      <ContentContainer hideable={hideable} isSidebarVisible={showSidebar} sidebarWidth={sidebarWidth}>
        {children}
      </ContentContainer>
    </Stack>
  );
}
